/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbPcs_item = {
    readonly serviceId: string | null;
    readonly " $refType": "PdpSharedBlurbPcs_item";
};
export type PdpSharedBlurbPcs_item$data = PdpSharedBlurbPcs_item;
export type PdpSharedBlurbPcs_item$key = {
    readonly " $data"?: PdpSharedBlurbPcs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbPcs_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ddd445e37ef1df753605b1afbaf5221b';
export default node;
